import FundPropertiesList from "./FundPropertiesList"

export default FundPropertiesList
